import { createFileRoute } from '@tanstack/react-router'

import BolumDetayPage from '@/features/bolumDetay'

export const Route = createFileRoute(
  '/_authenticated/bolumler/bolumDetay/$bolumId/',
)({

  component: BolumDetayPage,
})

export default Route
